import MarisaCareBanner from '~/assets/img/banners/marisa-care-web.png';
import MarisaCareMobileBanner from '~/assets/img/banners/marisa-care-mobile.png';
import MarisaAutoMobileBanner from '~/assets/img/banners/marisa-auto-mobile.png';
import MarisaAutoWebBanner from '~/assets/img/banners/marisa-auto-web.png';
import MarisaBagProtectionMobileBanner from '~/assets/img/banners/bag-protection-banner.png';
import MarisaBagProtectionWebBanner from '~/assets/img/banners/bag-protection-banner-web.png';
import MarisaIncomeProtectionMobileBanner from '~/assets/img/banners/income-protection-banner.png';
import MarisaIncomeProtectionWebBanner from '~/assets/img/banners/income-protection-banner-web.png';
import { contractMarisaTakesCareUseCase } from '~/useCases/MarisaTakesCare/ContractMarisaTakesCareUseCase';
import { registerIntentionUseCase } from '~/useCases/PSF/RegisterIntentionUseCase';
import type { ContractMarisaTakesCare } from '~/domain/MarisaTakesCare/contractMarisaTakesCare';
import { registerContractUseCase } from '~/useCases/PSF/RegisterContractUseCase';
import { finishAutoInsuranceUseCase } from '~/useCases/AssegurouAutoUseCases/FinishAutoInsuranceUseCase';

import type { Insurance } from '~/@types/insurance';
import { contractBagProtectionUseCase } from '~/useCases/BagProtectionUseCases/ContractBagProtectionUseCase';
import { contractIncomeProtectionUseCase } from '~/useCases/IncomeProtectionUseCases/ContractIncomeProtectionUseCase';
import type { ContractBagProtectionResponse } from '~/domain/BagProtection/contractBagProtection';
import type { ContractIncomeProtectionResponse } from '~/domain/IncomeProtection/contractIncomeProtection';

const INSURANCES: Insurance.Information[] = [
  {
    type: 'marisa-cuida',
    name: 'Marisa Cuida',
    description: 'A Marisa Cuida da sua saúde para você.',
    banner: {
      web: MarisaCareBanner,
      mobile: MarisaCareMobileBanner,
    },
    paymentMethods: [
      {
        code: '1',
        method: 'credit-card',
        description: 'Cartão de crédito',
        installments: [
          {
            id: 1,
            description: 'PARCELA MENSAL',
            price: 29.9,
          },
        ],
      },
    ],
    value: 29.9,
    doCheckout: contractMarisaTakesCareUseCase,
    onSuccess: async (data: ContractMarisaTakesCare) => {
      if (data.resultData) {
        const intentionResponse = await registerIntentionUseCase({
          certificateCode: data.resultData.certificateCode,
          document: data.resultData.insuredDocument,
          insuranceCompanyCode: 'REDEMAIS',
          insuranceCompanyName: 'REDE MAIS',
          type: 'MARISACUIDA',
        });

        if (intentionResponse) {
          await registerContractUseCase({
            transactionNumber: data.resultData.certificateCode,
            certificateCode: data.resultData.certificateCode,
            document: data.resultData.insuredDocument,
            totalPrize: 29.9,
            type: 'MARISACUIDA',
          });
        }
      }
    },
  },
  {
    type: 'marisa-auto',
    name: 'Seguro Auto',
    description: 'Aqui temos o seguro certo para o seu carro.',
    additionalText:
      'Seguro comercializado pela Assegurou Cor. de Seguros Ltda. SUSEP n.º 212109181',
    banner: {
      web: MarisaAutoWebBanner,
      mobile: MarisaAutoMobileBanner,
    },
    paymentMethods: [],
    doCheckout: finishAutoInsuranceUseCase,
  },
  {
    type: 'bag-protection',
    name: 'Proteção Bolsa',
    description: 'A tranquilidade que você merece.',
    banner: {
      web: MarisaBagProtectionWebBanner,
      mobile: MarisaBagProtectionMobileBanner,
    },
    paymentMethods: [
      {
        code: '1',
        method: 'credit-card',
        description: 'Cartão de crédito',
        installments: [
          {
            id: 1,
            description: 'PARCELA MENSAL',
            price: 10.99,
          },
        ],
      },
    ],
    value: 10.99,
    doCheckout: contractBagProtectionUseCase,
    onSuccess: async (data: ContractBagProtectionResponse) => {
      if (data.resultData) {
        const intentionResponse = await registerIntentionUseCase({
          certificateCode: data.resultData.certificateCode,
          document: data.resultData.insuredDocument,
          insuranceCompanyCode: 'ASSURANT',
          insuranceCompanyName: 'ASSURANT',
          type: 'BOLSAPROTEGIDA',
        });

        if (intentionResponse) {
          await registerContractUseCase({
            transactionNumber: data.resultData.certificateCode,
            certificateCode: data.resultData.certificateCode,
            document: data.resultData.insuredDocument,
            totalPrize: 29.9,
            type: 'BOLSAPROTEGIDA',
          });
        }
      }
    },
  },
  {
    type: 'income-protection',
    name: 'Proteção Perda de Renda',
    description: 'Você preparada quando for pega de surpresa.',
    banner: {
      web: MarisaIncomeProtectionWebBanner,
      mobile: MarisaIncomeProtectionMobileBanner,
    },
    paymentMethods: [
      {
        code: '1',
        method: 'credit-card',
        description: 'Cartão de crédito',
        installments: [
          {
            id: 1,
            description: 'PARCELA MENSAL',
            price: 17.99,
          },
        ],
      },
    ],
    value: 17.99,
    doCheckout: contractIncomeProtectionUseCase,
    onSuccess: async (data: ContractIncomeProtectionResponse) => {
      if (data.resultData) {
        const intentionResponse = await registerIntentionUseCase({
          certificateCode: data.resultData.certificateCode,
          document: data.resultData.insuredDocument,
          insuranceCompanyCode: 'ASSURANT',
          insuranceCompanyName: 'ASSURANT',
          type: 'PERDARENDA',
        });

        if (intentionResponse) {
          await registerContractUseCase({
            transactionNumber: data.resultData.certificateCode,
            certificateCode: data.resultData.certificateCode,
            document: data.resultData.insuredDocument,
            totalPrize: 29.9,
            type: 'PERDARENDA',
          });
        }
      }
    },
  },
];

export default INSURANCES;
